import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { MaterialsListPage } from "@/modules/material/pages/MaterialsList.page";

export const Route = createFileRoute("/__authed/m/materials/")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_materials")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: MaterialsListPage,
});
